import {UpdateUserRequest} from "@/model/request/user/UpdateUserRequest.ts";
import {CreateUserRequest} from "@/model/request/user/CreateUserRequest.ts";
import {BaseService} from "@/service/BaseService.ts";
import {ReadUserByWorkspaceIdRequest} from "@/model/request/user/ReadUserByWorkspaceIdRequest.ts";

export class UserService {
    static readAllUser = (others: any) => {
        return BaseService.apiClient(others).get("/user/read")
    }
    static updateUser = (data: UpdateUserRequest, others: any) => {
        return BaseService.apiClient(others).post("/user/update", data)
    }
    static createUser = (data: CreateUserRequest, others: any) => {
        return BaseService.apiClient(others).post("/user/create", data)
    }
    static readUserByWorkspaceId = (others: any, data: ReadUserByWorkspaceIdRequest,) => {
        return BaseService.apiClient(others).get(`/user/read-by-user-workspace-id/${data.workspaceId}`)
    }
}